// File: src/components/layouts/SidebarLayout/SidebarLayout.tsx

import { SidebarSplit } from "../../bars";
import React, { useMemo } from "react";
import styled from "styled-components";

interface SidebarLayoutProps {
  leftSidebar: React.ReactNode;
  main: React.ReactNode;
  rightPanel?: React.ReactNode;
  rightPanelCollapsed?: boolean;
}

const LayoutWrapper = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

const LeftSidebarContainer = styled.div`
 
`;

const MainContainer = styled.main`
  flex: 1;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing.lg};
  background: ${({ theme }) => theme.colors.background};
`;

const RightPanelContainer = styled.div<{ collapsed?: boolean }>`
  width: ${({ collapsed }) => (collapsed ? "0" : "350px")};
  transition: width 1.5s ease;
  overflow: true;

  background: ${({ theme }) => theme.colors.surface};
   border-left: 0.5px solid ${({ theme }) => theme.colors.border};
//   box-shadow: ${({ theme }) => theme.elevations.low};
`;

export const SidebarLayout: React.FC<SidebarLayoutProps> = ({
  leftSidebar,
  main,
  rightPanel,
  rightPanelCollapsed = false,
}) => {


  return (
    <LayoutWrapper>
      <LeftSidebarContainer>{leftSidebar}</LeftSidebarContainer>
      <MainContainer>{main}</MainContainer>
      {rightPanel && (
        <RightPanelContainer collapsed={rightPanelCollapsed}>
          {!rightPanelCollapsed && rightPanel}
        </RightPanelContainer>
      )}
    </LayoutWrapper>
  );
};